<template>
  <div class="modal-card"
       style="width: 500px">
    <header class="modal-card-head is-small">
      <p class="modal-card-title">陸送料金更新</p>
      <span class="v-icon-close" style="cursor: pointer;"
            @click="$emit('close')">
        <b-icon size="is-medium"
                pack="fa"
                icon="window-close"> </b-icon>
      </span>
    </header>
    <section class="modal-card-body v-custorm-body">
      <div class="group-column">
        <div class="field">
          <p class="field-label">陸送会社</p>
          <p class="field-value">{{ (item.dataFee.inlandCompanyFee[indexCompany].company_name) }}</p>
        </div>
      </div>
      <div class="group-column">
        <div class="group-field">
          <div class="field-child">
            <p class="field-label">オークション会場</p>
            <p class="field-value">{{ item.transportFromName }}</p>
          </div>

          <div class="field-child">
            <p class="field-label">Yard City1</p>
            <p class="field-value">{{ item.yardCity1 }}</p>
          </div>
        </div>
      </div>
      <div class="group-column">
        <div class="field">
          <p class="field-label">現在料金</p>
          <p class="field-value">{{ (item.dataFee.inlandCompanyFee[indexCompany].setting_fee | formatNumber) }}</p>
        </div>
      </div>

      <div class="group-column">
        <div class="field">
          <p class="field-label">変更金額</p>
          <b-input class="input-setting-fee"
                   v-model="setting_fee_new" />

        </div>
        <span style="color: red; font-size: 15;">{{ msgSettingFee }}</span>
      </div>

      <div class="group-column">
        <b-button class="field field-button"
                  label="更新"
                  @click="updateCompanyFee();" />


      </div>
    </section>
  </div>
</template>

<script>
import jcPackage from '@/repositories/jcPackage';
const regexFormatNumber = /^[0-9]+$/;
const regexEmppty = /^$/;
export default {
  props: [
    'item', 'indexCompany', 'token'
  ],
  data: () => ({
    setting_fee_new: '',
    errSettingFee: '',
    msgSettingFee: ''
  }),
  computed: {

  },
  methods: {
    updateCompanyFee() {

      if (regexEmppty.test(this.setting_fee_new)) {
        this.errSettingFee = 'is-danger';
        this.msgSettingFee = '変更金額を入力してください。';
        return;
      } else {
        if (regexFormatNumber.test(this.setting_fee_new)) {
          this.errSettingFee = '';
          this.msgSettingFee = '';
        } else {
          this.errSettingFee = 'is-danger';
          this.msgSettingFee = '数字のみ入力してください。';
          return;
        }
      }

      const params = {
        setting_fee_id: this.item.dataFee.inlandCompanyFee[this.indexCompany].setting_fee_id,
        setting_fee: this.setting_fee_new
      };
      jcPackage
        .updateFeeCompany(
          this.token,
          params
        )
        .then((rs) => {
          this.item.dataFee.inlandCompanyFee[this.indexCompany].setting_fee = this.setting_fee_new;
          this.$emit('close');
        })
        .catch((err) => {
          console.log('updateFeeCompany', err);
        });
    }
  },
};
</script>

<style>
.group-column {
  width: 80%;
  margin: auto;
  padding: 0.5rem 0.75rem !important;
  display: block;
}

.group-column .field {
  width: 100%;
  border: 1px solid #b5b5b5;
  border-radius: 6px;
}

.group-column .field p {
  width: 100%;
  height: 35px;
  line-height: 2;
  text-align: center;
}

.field-value {
  border-top: 1px solid #b5b5b5;
  background-color: #d7d7d7;
}

.group-field {
  display: flex;
  gap: 5%;
}

.field-child {
  width: 50%;
  margin-bottom: 0;
  border: 1px solid #b5b5b5;
  border-radius: 6px;
}

.field-child p {
  width: 100%;
  height: 35px;
  line-height: 2;
  text-align: center;
}

.input-setting-fee input {
  border: none;
  border-top: 1px solid #b5b5b5;
  border-radius: 0;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  box-shadow: none;
  text-align: center;
}

.field-label {
  font-weight: 600;
}

.field-button {
  width: 25% !important;
  margin-left: 40%;
}
</style>
